// extracted by mini-css-extract-plugin
export var cardIcon = "_ap-5";
export var cardIconUnframed = "_ap-9";
export var checkboxCard = "_ap-0";
export var checkboxCardSelected = "_ap-4";
export var disabled = "_ap-2";
export var interactive = "_ap-1";
export var outerBorder = "_ap-3";
export var spacerMedium = "_ap-8";
export var spacerSmall = "_ap-7";
export var spacerXsmall = "_ap-6";